// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BandaidsBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m23.779 16 3.11-3.111A5.5 5.5 0 1 0 19.11 5.11L16 8.221l-3.111-3.11A5.5 5.5 0 1 0 5.11 12.89L8.221 16l-3.11 3.111a5.5 5.5 0 1 0 7.778 7.778L16 23.779l3.111 3.11a5.5 5.5 0 1 0 7.778-7.778L23.779 16Zm-2.546-8.767a2.5 2.5 0 1 1 3.534 3.535l-3.11 3.107-3.532-3.531 3.108-3.111ZM19.535 16 16 19.535 12.465 16 16 12.465 19.535 16ZM7.232 10.768a2.5 2.5 0 1 1 3.535-3.535l3.108 3.11-3.531 3.532-3.112-3.107Zm3.535 14a2.5 2.5 0 1 1-3.535-3.535l3.112-3.108 3.531 3.531-3.108 3.111Zm14 0a2.5 2.5 0 0 1-3.534 0l-3.108-3.112 3.531-3.531 3.111 3.111a2.5 2.5 0 0 1 0 3.535v-.004Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
